<template>
  <div
    class="layout-root layout-dark">
    <template>
      <!-- begin::Body -->
      <div class="page page-bg-dark">
          <!-- begin:: Header -->
          <Header></Header>
          <!-- end:: Header -->

          <!-- begin:: Content -->
          <main class="main-page" :class="{ 'pt-3xl': isMobile }">
            <div class="layout-flex-container">
              <bf-row type="flex" justify="center" align="middle">
                <router-view />
              </bf-row>
            </div><!-- /.layout-flex-container -->
          </main>

          <!-- Begin::Animation Lines -->
          <div class="lines">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
          </div>
          <!-- End::Animation Lines -->
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '@/components/commons/Header.vue';

export default {
  name: 'LayoutContainer',
  components: {
    Header,
  },
  computed: {
    ...mapGetters('device', [
      'isMobile',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/_variables';

.page {
  padding-top: $lo-nav-height;
  padding-bottom: $footer-height;
}
.main-page {
  min-height: calc(100vh - $lo-nav-height - $footer-height);
  display: flex;
}
@media (max-width: $breakpoint) {
  .page {
    padding-top: $hd-nav-height-mb;
    padding-bottom: 0;
  }
  .main-page {
    min-height: calc(100vh);
  }
  .page.page-bg-dark::before {
    padding-bottom: $hd-nav-height-mb;
  }
}

.page.page-bg-dark {
  background-color: $lo-bg-dark-color;
  background:linear-gradient(105.84deg, #00A1E7 -23.36%, #5C42FB 110.69%), #F5F9FF;
}
.page.page-bg-dark::before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-image: url(./../assets/images/bg.png);
  background-position: center top;
  background-size: 100% auto;
  pointer-events: none;
  animation: gradient 90s 0s infinite;
}
/* Line animation */
.lines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100vh;
  pointer-events: none;
  overflow: hidden;
}
.line {
  position: absolute;
  width: 1px;
  height: 100%;
  top: 0;
  left: 50%;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  pointer-events: none;
  transform: rotate(-45deg);
  &::after {
    content: '';
    display: block;
    position: absolute;
    height: 15vh;
    width: 100%;
    top: -50%;
    left: 0;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #ffffff 75%, #ffffff 100%);
    animation: drop 3.5s 0s infinite;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(0.4, 0.26, 0, 0.97);
    pointer-events: none;
  }
  &:nth-child(1) {
    margin-left: -25%;
    &::after {
      animation-delay: 2s;
    }
  }
  &:nth-child(3) {
    margin-left: 25%;
    &::after {
      animation-delay: 2.5s;
    }
  }
}

@keyframes drop {
  0% {
    top: -50%
  }
  100%  {
    top: 110%
  }
}

@keyframes gradient {
 0% {
  background-size: 100% 100% ;
  opacity: 0.2;
 }
 50% {
  background-size: 120% 120% ;
  opacity: 0.5;
 }
 100% {
  background-size: 100% 100% ;
  opacity: 0.2;
 }
}
</style>
